export default {
    computed: {
        $documentView() {
            return {
                setFullHeight: () => {
                    let newZoom;
                    if (this.isMainImgLandscape) {
                        newZoom = (this.$documentView.calcHeight() / this.getMainImageParams.width).toFixed(2);
                    } else {
                        newZoom = (this.$documentView.calcHeight() / this.getMainImageParams.height).toFixed(2);
                    }
                    if (this.getZoom !== newZoom) {
                        this.$store.commit('SET_NEW_ZOOM', newZoom);
                    }
                },
                setFullWidth: () => {
                    let newZoom;
                    if (this.isMainImgLandscape) {
                        newZoom = (this.$documentView.calcWidth() / this.getMainImageParams.height).toFixed(2);
                    } else {
                        newZoom = (this.$documentView.calcWidth() / this.getMainImageParams.width).toFixed(2);
                    }
                    if (this.getZoom !== newZoom) {
                        this.$store.commit('SET_NEW_ZOOM', newZoom);
                    }
                },
                calcWidth: () => {
                    const { left } = document.querySelector('.document-page__view').getBoundingClientRect();
                    return window.innerWidth - left;
                },
                calcHeight: () => {
                    const { height, top } = document.querySelector('.document-page__view').getBoundingClientRect();
                    return this.isMobile ? window.innerHeight - top : height;
                }
            };
        }
    }
};
